import React from 'react'
import {
  List,
} from './index'
import { SystemProvider } from '../../../features/system/provider'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'query-string'
import { CollectionList } from '../../../features/collection/components/collection-list'

/**
 * @glossary
 * - data: post type's bulk data
 * - pageItems: chunk of bulk data to be rendered, per page
 */

const PaginatedList = ({query, events: defaultData, pageConfig, actions}) => {
  const { fetchEvents: fetcher, setCurrentPage, setPageItems, setSorter, setStatus } = actions
  const { USE_PAGINATION_API, SORT_OPTIONS, STATE_KEY } = pageConfig
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [show, setShow] = React.useState(true);
  const [data, setData] = React.useState(defaultData);
  const [finalTotalData, setFinalTotalData] = React.useState(0)
  const [finalWithPaginationAPI, setFinalWithPaginationAPI] = React.useState(false)
  const [finalDataToRender, setFinalDataToRender] = React.useState([])
  const { itemsPerPage, pageItems, totalItems, status, currentPage } = useSelector(state => state[STATE_KEY])

  const handleCurrentPageChange = (newCurrentPage) => {
    if(newCurrentPage !== currentPage){
      dispatch(setCurrentPage(newCurrentPage)).then((res) => {
        if(status !== 'loading'){
          const limit = itemsPerPage
          const offset = (res.payload-1)*itemsPerPage
          dispatch(fetcher({...query, limit, offset}))
        }
      })
    }
  }

  // If with API Pagination
  const handleSorterChange = (newSorter) => {
    console.log({newSorter})
    dispatch(setSorter(newSorter)).then((res) => {
      const value = res.payload.value;
      let translated = false;

      if (value === "oldest") {
        translated = "asc";
      } else if (value === "newest") {
        translated = "desc";
      }

      else if (value === "az") {
        translated = "asc";
      } else if (value === "za") {
        translated = "desc";
      }

      if (translated) {
        const limit = itemsPerPage;
        const offset = (currentPage - 1) * itemsPerPage;

        const cloned = {...query}
        if (cloned.date) delete cloned.date
        if (cloned.name) delete cloned.name
        if (cloned.title) delete cloned.title
        if (cloned.sort_by_title) delete cloned.sort_by_title

        const finalKey = newSorter.key === 'title' ? 'sort_by_title' : newSorter.key

        const newQuery = { ...cloned, limit, offset, [finalKey]: translated };

        const searchString = qs.stringify(newQuery);
        const currentPath = location.pathname;

        history.replace({
          pathname: currentPath,
          search: "?" + searchString,
        });
      }
    });
  };

  React.useEffect(() => {
    if(show === true){
      setShow(false)
      // Handle programs paginated list on organization detail
      const dataIsNotEmpty = data && data.length > 0
      const pageItemsIsEmpty = pageItems && pageItems.length === 0
      const somethingIsWrong = dataIsNotEmpty && pageItemsIsEmpty

      if(somethingIsWrong){
        console.error('something is wrong in resource paginated list line ~84', {data, pageItems})
      }

      setFinalWithPaginationAPI(somethingIsWrong ? false : USE_PAGINATION_API)
      setFinalDataToRender(somethingIsWrong ? defaultData : pageItems)

      const totalItemsFallback =
        totalItems && totalItems > 0 && totalItems > pageItems.length ? totalItems :
        pageItems.length

      setFinalTotalData(somethingIsWrong ? data.length : totalItemsFallback)

      setTimeout(() => {
        setShow(true)
      }, 100)
    }
    // eslint-disable-next-line
  }, [data, totalItems, pageItems])

  return (
    <>
      {
        show &&
        <CollectionList
          query={query}
          sortOptions={SORT_OPTIONS}
          setStatus={setStatus}
          data={finalDataToRender}
          setData={setData}
          itemsPerPage={itemsPerPage}
          setPageItems={setPageItems}
          totalData={finalTotalData}
          setCurrentPage={handleCurrentPageChange}
          defaultCurrentPage={currentPage}
          withPaginationAPI={finalWithPaginationAPI}
          setSorter={handleSorterChange}
        >
          {
            finalDataToRender &&
            <SystemProvider>
              <List data={finalDataToRender}/>
            </SystemProvider>
          }
        </CollectionList>
      }
    </>
  )
}

export default PaginatedList
